import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import { useTranslation } from 'react-i18next';
import VideoPlayerDialog from './VideoPlayerDialog';

// This list must stay in sync with the HELP VIDEOS block in chatbot/services/gemini.py —
// the help chatbot can only recommend videos it has been told about.
const HELP_VIDEO_SECTIONS = [
  {
    sectionKey: 'Work orders',
    videos: [
      {
        titleKey: 'Create work order',
        youtubeId: 'P3MBfWA2HOk',
      },
      {
        titleKey: 'Importing parts to work orders',
        youtubeId: 'Zn5SZYZ2lMo',
      },
      {
        titleKey: 'Using scheduling calendar',
        youtubeId: 'oEMY4su-FUc',
      },
    ],
  },
  {
    sectionKey: 'Invoicing section',
    videos: [
      {
        titleKey: 'Invoicing a work order',
        youtubeId: 'wIiyDfRRf60',
      },
    ],
  },
  {
    sectionKey: 'Work time tracking section',
    videos: [
      {
        titleKey: 'Adding and reviewing work time entries',
        youtubeId: 'jGASpbfpsSM',
      },
    ],
  },
];

function HelpVideosDialog({ open, onClose }) {
  const { t } = useTranslation();
  const [selectedVideo, setSelectedVideo] = useState(null);

  const handleVideoClick = (video) => {
    setSelectedVideo(video);
  };

  const handlePlayerClose = () => {
    setSelectedVideo(null);
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          {t('Help videos')}
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers sx={{ p: 0 }}>
          <List disablePadding>
            {HELP_VIDEO_SECTIONS.map((section, sectionIndex) => (
              <React.Fragment key={sectionIndex}>
                <ListSubheader
                  sx={{
                    bgcolor: 'grey.100',
                    fontWeight: 600,
                    lineHeight: '40px',
                  }}
                >
                  {t(section.sectionKey)}
                </ListSubheader>
                {section.videos.map((video, videoIndex) => (
                  <ListItem
                    key={`${sectionIndex}-${videoIndex}`}
                    disablePadding
                    divider={
                      !(sectionIndex === HELP_VIDEO_SECTIONS.length - 1 &&
                        videoIndex === section.videos.length - 1)
                    }
                  >
                    <ListItemButton onClick={() => handleVideoClick(video)}>
                      <ListItemIcon>
                        <PlayCircleOutlineIcon color="primary" />
                      </ListItemIcon>
                      <ListItemText primary={t(video.titleKey)} />
                    </ListItemButton>
                  </ListItem>
                ))}
              </React.Fragment>
            ))}
          </List>
        </DialogContent>
      </Dialog>

      <VideoPlayerDialog
        open={!!selectedVideo}
        onClose={handlePlayerClose}
        videoTitle={selectedVideo ? t(selectedVideo.titleKey) : ''}
        youtubeId={selectedVideo?.youtubeId}
      />
    </>
  );
}

export default HelpVideosDialog;
